var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popover',{attrs:{"placement":"bottom","trigger":"hover-focus","custom-class":"popover-as-tooltip avatar-popover"}},[_c('span',{class:[
      'user-initials-badge',
      'fs-exclude',
      `user-initials-${_vm.userUuid || 'unknown'}`,
      { 'current-user-bg': _vm.userUuid === _vm.userId }
    ],attrs:{"aria-label":`${_vm.userRole}: ${_vm.userName}`,"tabindex":"0"}},[_vm._v("\n    "+_vm._s(_vm.userInitial)+"\n  ")]),_vm._v(" "),_c('template',{slot:"popover"},[_c('p',{staticClass:"fs-exclude"},[_vm._v(_vm._s(_vm.userName)+" "),(_vm.userUuid === _vm.userId)?_c('span',[_vm._v("(Me)")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"fs-exclude"},[_vm._v(_vm._s(_vm.userEmail))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }